module.exports = __webpack_public_path__ + "img/User - Active.bd5e3040.svg";